export default "__VITE_ASSET__CcpXH8T6__"